import React from 'react';
import { useTranslation } from 'react-i18next';
import './RequiredErrorMessage.scss';

interface Props {
  isNotRequired?: boolean;
  isRequiredChangeRevisionDate?: boolean;
}

const RequiredErrorMessage = ({ isNotRequired, isRequiredChangeRevisionDate = false }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="required-error-message-container">
      {(!isNotRequired && !isRequiredChangeRevisionDate) && <span className="error-icon"></span>}
      <span className={`message ${(isNotRequired || isRequiredChangeRevisionDate) ? 'color-not-required' : 'color-required'}`}>
        {t(isRequiredChangeRevisionDate
          ? 'update_revision_date_warning' : 
          isNotRequired ? 'required_data_from_approve' : 'required_data')}
      </span>

    </div>
  );
};

export default RequiredErrorMessage;
